import { CoreValueWrap } from "../styles/common/coreValue.styled";

const CoreValue = () => {
  return (
    <CoreValueWrap>
      <div className="title-wrap">
        <div className="title-txt">
          <svg
            className="pc_only"
            width="299"
            height="35"
            viewBox="0 0 299 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M34.127 14.72H22.687C22.607 12.92 21.807 9.48 17.527 9.48C12.727 9.48 11.367 12.8 11.367 17.88V18.08C11.367 23.12 12.727 26.48 17.527 26.48C21.287 26.48 22.727 24.08 22.807 21H34.367C34.527 27.92 28.567 34.76 17.847 34.76C5.28703 34.76 0.00703131 28.84 0.00703131 18C0.00703131 7.08 5.68703 1.2 17.847 1.2C27.607 1.2 33.687 6.04 34.127 14.72ZM52.0133 8.32C60.9733 8.32 67.6133 11.84 67.6133 21.6C67.6133 32.28 61.0533 34.8 52.0133 34.8C42.9333 34.8 36.4133 32.28 36.4133 21.6C36.4133 11.84 43.0533 8.32 52.0133 8.32ZM52.0133 27.8C55.7733 27.8 57.4133 25.88 57.4133 21.76V21.16C57.4133 17.08 56.0133 15.24 52.0133 15.24C48.0133 15.24 46.6133 17.08 46.6133 21.16V21.76C46.6133 25.88 48.2533 27.8 52.0133 27.8ZM70.4258 34.2V9.12H80.8658L81.2658 11.92H81.3858C82.9058 10.08 85.2658 8.48 89.7058 8.48C90.8658 8.48 91.9458 8.64 93.0658 8.88V17.32C91.9458 16.96 90.9058 16.68 88.6258 16.68C84.0658 16.68 81.7458 18.84 81.7458 24.32V34.2H70.4258ZM114.11 26H124.23C122.59 33.08 117.27 34.8 109.67 34.8C100.59 34.8 94.0695 32.28 94.0695 21.6C94.0695 11.84 100.71 8.32 109.67 8.32C118.63 8.32 124.55 12.24 124.71 21.6C124.71 22.44 124.63 23.44 124.55 24.2H104.47C105.03 27.04 106.71 28.24 109.95 28.24C111.95 28.24 113.87 27.56 114.11 26ZM109.67 15.24C106.59 15.24 105.03 16.08 104.47 18.52H114.47C113.99 16.28 112.67 15.24 109.67 15.24ZM174.419 1.84L162.339 34.2H149.859L138.299 1.84H149.779L156.059 21.72H156.139L162.419 1.84H174.419ZM201.178 20.44V34.2H190.658L190.258 32.68H190.138C187.458 34.32 184.378 34.8 180.738 34.8C175.138 34.8 171.218 32.56 171.218 27.4C171.218 19.56 181.218 18.64 189.858 18.16V17.8C189.858 15.24 188.098 14.64 186.298 14.64C182.898 14.64 182.698 16.08 182.698 17.28H172.298C172.458 10.2 179.738 8.32 186.618 8.32C199.338 8.32 201.178 13.96 201.178 20.44ZM189.858 25.88V23.64C188.578 23.8 187.258 24 185.618 24.36C183.138 24.92 181.818 25.36 181.818 27.04C181.818 28.36 182.898 28.88 184.978 28.88C187.458 28.88 189.858 27.48 189.858 25.88ZM216.551 0.599998V34.2H205.191V0.599998H216.551ZM231.463 9.12V22.32C231.463 26.2 233.543 27.84 236.103 27.84C239.223 27.84 240.663 26.08 240.663 22.32V9.12H251.983V34.2H241.823L241.423 32.56H241.343C239.583 33.84 237.303 34.8 232.623 34.8C224.223 34.8 220.543 30.04 220.543 21.76V9.12H231.463ZM274.813 26H284.933C283.293 33.08 277.973 34.8 270.373 34.8C261.293 34.8 254.773 32.28 254.773 21.6C254.773 11.84 261.413 8.32 270.373 8.32C279.333 8.32 285.253 12.24 285.413 21.6C285.413 22.44 285.333 23.44 285.253 24.2H265.173C265.733 27.04 267.413 28.24 270.653 28.24C272.653 28.24 274.573 27.56 274.813 26ZM270.373 15.24C267.293 15.24 265.733 16.08 265.173 18.52H275.173C274.693 16.28 273.373 15.24 270.373 15.24ZM298.399 34.2H287.599V26.08H298.399V34.2Z"
              fill="white"
            />
          </svg>
          <svg
            className="pc_none"
            width="240"
            height="28"
            viewBox="0 0 240 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28.2016 11.576H19.0496C18.9856 10.136 18.3456 7.384 14.9216 7.384C11.0816 7.384 9.99363 10.04 9.99363 14.104V14.264C9.99363 18.296 11.0816 20.984 14.9216 20.984C17.9296 20.984 19.0816 19.064 19.1456 16.6H28.3936C28.5216 22.136 23.7536 27.608 15.1776 27.608C5.12963 27.608 0.905625 22.872 0.905625 14.2C0.905625 5.464 5.44963 0.759998 15.1776 0.759998C22.9856 0.759998 27.8496 4.632 28.2016 11.576ZM42.5106 6.456C49.6786 6.456 54.9906 9.272 54.9906 17.08C54.9906 25.624 49.7426 27.64 42.5106 27.64C35.2466 27.64 30.0306 25.624 30.0306 17.08C30.0306 9.272 35.3426 6.456 42.5106 6.456ZM42.5106 22.04C45.5186 22.04 46.8306 20.504 46.8306 17.208V16.728C46.8306 13.464 45.7106 11.992 42.5106 11.992C39.3106 11.992 38.1906 13.464 38.1906 16.728V17.208C38.1906 20.504 39.5026 22.04 42.5106 22.04ZM57.2406 27.16V7.096H65.5926L65.9126 9.336H66.0086C67.2246 7.864 69.1126 6.584 72.6646 6.584C73.5926 6.584 74.4566 6.712 75.3526 6.904V13.656C74.4566 13.368 73.6246 13.144 71.8006 13.144C68.1526 13.144 66.2966 14.872 66.2966 19.256V27.16H57.2406ZM92.1876 20.6H100.284C98.9716 26.264 94.7156 27.64 88.6356 27.64C81.3716 27.64 76.1556 25.624 76.1556 17.08C76.1556 9.272 81.4676 6.456 88.6356 6.456C95.8036 6.456 100.54 9.592 100.668 17.08C100.668 17.752 100.604 18.552 100.54 19.16H84.4756C84.9236 21.432 86.2676 22.392 88.8596 22.392C90.4596 22.392 91.9956 21.848 92.1876 20.6ZM88.6356 11.992C86.1716 11.992 84.9236 12.664 84.4756 14.616H92.4756C92.0916 12.824 91.0356 11.992 88.6356 11.992ZM140.435 1.272L130.771 27.16H120.787L111.539 1.272H120.723L125.747 17.176H125.811L130.835 1.272H140.435ZM161.842 16.152V27.16H153.426L153.106 25.944H153.01C150.866 27.256 148.402 27.64 145.49 27.64C141.01 27.64 137.874 25.848 137.874 21.72C137.874 15.448 145.874 14.712 152.786 14.328V14.04C152.786 11.992 151.378 11.512 149.938 11.512C147.218 11.512 147.058 12.664 147.058 13.624H138.738C138.866 7.96 144.69 6.456 150.194 6.456C160.37 6.456 161.842 10.968 161.842 16.152ZM152.786 20.504V18.712C151.762 18.84 150.706 19 149.394 19.288C147.41 19.736 146.354 20.088 146.354 21.432C146.354 22.488 147.218 22.904 148.882 22.904C150.866 22.904 152.786 21.784 152.786 20.504ZM174.141 0.279999V27.16H165.053V0.279999H174.141ZM186.07 7.096V17.656C186.07 20.76 187.734 22.072 189.782 22.072C192.278 22.072 193.43 20.664 193.43 17.656V7.096H202.486V27.16H194.358L194.038 25.848H193.974C192.566 26.872 190.742 27.64 186.998 27.64C180.278 27.64 177.334 23.832 177.334 17.208V7.096H186.07ZM220.75 20.6H228.846C227.534 26.264 223.278 27.64 217.198 27.64C209.934 27.64 204.718 25.624 204.718 17.08C204.718 9.272 210.03 6.456 217.198 6.456C224.366 6.456 229.102 9.592 229.23 17.08C229.23 17.752 229.166 18.552 229.102 19.16H213.038C213.486 21.432 214.83 22.392 217.422 22.392C219.022 22.392 220.558 21.848 220.75 20.6ZM217.198 11.992C214.734 11.992 213.486 12.664 213.038 14.616H221.038C220.654 12.824 219.598 11.992 217.198 11.992ZM239.619 27.16H230.979V20.664H239.619V27.16Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="title-detail">
          <p className="title-detail-item">모두가 능동적으로 삶을 살아가는 세상</p>
        </div>
      </div>
      <div className="contents-wrap">
        <div className="valueBox-list">
          <div className="valueBox-item">
            <div className="tag">넥스트러너스가 할 일</div>
            <div className="value-text">
              <div className="value-title">개인이 성장할 시간과 환경을 보장</div>
              <div className="value-subTitle">
                회사만 성장하는 곳 = 개인의 노동을 착취만 하는 곳
              </div>
            </div>
          </div>
          <div className="value-line"></div>
          <div className="value-desc-wrap">
            <ul className="desc-list">
              <li className="desc-item">회사는 회사와 구성원 모두 함께 성장하는 곳 </li>
              <li className="desc-item">누구나 쉽게 실험하고 도전할 수 있는 챌린지 제도</li>
              <li className="desc-item">개인이 꾸준히 발전할 수 있도록 전폭적인 교육 지원</li>
              <li className="desc-item">성과에 따라 제공되는 인센티브와 가파른 연봉 인상</li>
            </ul>
          </div>
        </div>
        <div className="valueBox-list">
          <div className="valueBox-item">
            <div className="tag">러너즈가 할 일</div>
            <div className="value-text">
              <div className="value-title">회사의 성장을 위한 몰입과 노력</div>
              <div className="value-subTitle">
                개인만 성장하는 곳 = 회사가 아닌 자기 계발 동아리
              </div>
            </div>
          </div>
          <div className="value-line"></div>
          <div className="value-desc-wrap">
            <ul className="desc-list">
              <li className="desc-item">회사 성장에 기여되는 방향으로 개인의 성장 방향 설정</li>
              <li className="desc-item">구성원 스스로 긴장감을 유지할 수 있는 규칙과 환경 구축</li>
              <li className="desc-item">회사의 목표 성과 달성에 대한 집요함과 책임감 탑재 </li>
            </ul>
          </div>
        </div>
        <div className="bg-circle">
          <svg
            className="pc_only"
            width="540"
            height="540"
            viewBox="0 0 620 620"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="310"
              cy="310"
              r="270"
              fill="#171717"
              stroke="#111111"
              strokeOpacity="0.8"
              strokeWidth="80"
            />
          </svg>
          <svg
            className="pc_none"
            width="320"
            height="320"
            viewBox="0 0 320 320"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="160"
              cy="160"
              r="120"
              fill="#171717"
              stroke="#111111"
              strokeOpacity="0.8"
              strokeWidth="80"
            />
          </svg>
        </div>
      </div>
    </CoreValueWrap>
  );
};

export default CoreValue;
